import React, { PropTypes } from 'react';
import classNames from 'classnames';

import InputGroup from '../InputGroup';
import BaseField from './Base';


export default class Radio extends BaseField {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired).isRequired,
    label: PropTypes.string,
    group: PropTypes.shape({}),
    inline: PropTypes.bool.isRequired
  };

  static defaultProps = {
    inline: false
  };

  render() {
    const { id } = this.state;
    const {
      inline,
      options,
      group,
      label,
      input: {value: currentValue, ...input},
      meta: { error, invalid }
    } = this.props;

    return (
      <InputGroup id={id} invalid={invalid} label={label} {...group}>
        {options.map(({ label, value }, idx) =>
          <div className={classNames("from-check", {"form-check-inline": inline })} key={idx}>
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                {...input}
                value={value}
                checked={value === currentValue}
              />
              {' '}{label}
            </label>
          </div>
        )}
        { error && <div className="form-control-feedback">{error}</div> }
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field/Radio.js